import styled from 'styled-components';
import { View } from './View';

export const ScreenContainer = styled(View)`
  max-width: 1148px;
  width: 100%;
  align-self: center;
`;
